// extracted by mini-css-extract-plugin
export default {"cover":"styles_cover__Qn+It","modal":"styles_modal__mCwDO","modalTitle":"styles_modalTitle__nujy3","buttons":"styles_buttons__lU4VR"};